import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Kpi } from '@models';

@Component({
  selector: 'kpi-charts-panel-header',
  templateUrl: './kpi-charts-panel-header.component.html',
  styleUrl: './kpi-charts-panel-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiChartsPanelHeaderComponent {
  @Input() kpi: Kpi | undefined;
  @Input() protocolNumber!: string;
  @Input() secondaryValue?: string;
  @Input() displayValue?: number | string;
  @Input() displayUnit?: string;

  computeTrendText(kpiTrendText: string | undefined) {
    if (kpiTrendText === undefined) {
      return '';
    }
    if (kpiTrendText.toLowerCase().startsWith('no change')) {
      return `${kpiTrendText}: `;
    }
    return `Trend ${kpiTrendText.toLowerCase()}: `;
  }
}
